import React from "react";
import logo from "../../../img/Zais_logo.png";

export const AcceptInvitationShell = ({ wide = false, children }) => (
  <section className="login accept-supplier-invite">
    <div
      className={`login_part signup_middle accept-supplier-invite__part${
        wide ? " accept-supplier-invite__part--wide" : ""
      }`}
    >
      <div className="sing_log accept-supplier-invite__card">{children}</div>
    </div>
  </section>
);

export const InvitationLogo = () => (
  <div className="sing_one mb-3 text-center">
    <img
      src={logo}
      alt="Zais Tech"
      className="accept-supplier-invite__logo"
    />
  </div>
);

export const SectionCard = ({ title, children }) => (
  <div className="accept-supplier-invite__section">
    <h5 className="accept-supplier-invite__section-title">{title}</h5>
    {children}
  </div>
);

export const Field = ({ label, required, error, children }) => (
  <div className="form-group fg mb-3">
    <label className="st_name">
      {label}
      {required ? " *" : ""}
    </label>
    {children}
    {error ? <div className="help-block">{error}</div> : null}
  </div>
);

export const fieldsetResetStyle = {
  border: 0,
  margin: 0,
  padding: 0,
  minWidth: 0,
};
